
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

// Components
import Header from './components/master/Header';

// Pages
import ImpactsTracking from './pages/ImpactsTracking';
import ImpactsTrackingDash from 'pages/ImpactsTrackingDash';
import StrategicObjectives from 'pages/StrategicObjectives';
// Icons & Images
import BackIcon from "assets/icons/backicon.svg";


import './App.css';
import './assets/scss/master.scss';


function App() {
  const location = useLocation();
  let navgiate = useNavigate();
  let pageTitle = '';
  if(location.pathname === '/') {
    pageTitle = 'Strategic Objective Dashboard';
  }
  if(location.pathname === '/impacts-tracking' || location.pathname === '/impacts-tracking-dashboard') {
    pageTitle = 'Impact Tracking Details';
  }
  return (
    <div className="main-content-wrapper">
      {
        location.pathname !== '/' && 
        <div className='back-button' onClick={()=> { navgiate('/') }}>
          <img src={BackIcon} alt="#"/>
       </div>
      }
       
      <Header meta={ { pagetitle: pageTitle }}/>
      <div className='main-content'>
        <Routes>
          <Route path="/" element={<StrategicObjectives/>} />
          <Route path="/impacts-tracking" element={<ImpactsTracking/>} />
          <Route path="/impacts-tracking-dashboard" element={<ImpactsTrackingDash />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
